<template>
  <div class="overflow-auto">
    <div class="line-header-wrapper">
      <div class="date-text">{{ 'Date' | i18n }}</div>
      <div class="type-input">{{ 'Type' | i18n }}</div>
      <div class="hint-input">{{ 'Hint' | i18n }}</div>
      <div class="number-text">{{ 'Week' | i18n }}</div>
      <div class="number-text">{{ 'Day' | i18n }}</div>
      <div class="number-text">{{ 'Delivery day' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A1 Plan' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A2 Plan' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A3 Plan' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A4 Plan' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A1 Ist' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A2 Ist' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A3 Ist' | i18n }}</div>
      <div class="hour-input">{{ 'BStd. A4 Ist' | i18n }}</div>
    </div>
    <div v-for="line in backendData" :key="line.date" class="line-wrapper">
      <div class="date-text">
        {{ moment(line.date).format('DD-MM-YYYY') }}
        {{ moment(line.date).format('ddd') | i18n }}
      </div>
      <div class="type-input">
        <Select
          :value="line.type"
          :onChange="(v) => setBackendData(v, 'type', line.date)"
          :options="typeOptions"
          form-group-id="Type"
          placeholder=""
        />
      </div>
      <div class="hint-input">
        <Input :value="line.hint" :onChange="(v) => setBackendData(v, 'hint', line.date)" form-group-id="Hint" placeholder="" />
      </div>
      <div class="number-text mt-3">{{ line['Kalender-woche'] }}</div>
      <div class="number-text mt-3">{{ line['Tag des Jahres'] }}</div>
      <div class="number-text mt-3">{{ line['Anliefertag des Jahres'] }}</div>
      <div class="hour-input">
        <Input
          :value="line.BStdA1Plan"
          :onChange="(v) => setBackendData(v, 'BStdA1Plan', line.date)"
          form-group-id="BStdA1Plan"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA2Plan"
          :onChange="(v) => setBackendData(v, 'BStdA2Plan', line.date)"
          form-group-id="BStdA2Plan"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA3Plan"
          :onChange="(v) => setBackendData(v, 'BStdA3Plan', line.date)"
          form-group-id="BStdA3Plan"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA4Plan"
          :onChange="(v) => setBackendData(v, 'BStdA4Plan', line.date)"
          form-group-id="BStdA4Plan"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA1Ist"
          :onChange="(v) => setBackendData(v, 'BStdA1Ist', line.date)"
          form-group-id="BStdA1Ist"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA2Ist"
          :onChange="(v) => setBackendData(v, 'BStdA2Ist', line.date)"
          form-group-id="BStdA2Ist"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA3Ist"
          :onChange="(v) => setBackendData(v, 'BStdA3Ist', line.date)"
          form-group-id="BStdA3Ist"
          placeholder=""
          type="number"
        />
      </div>
      <div class="hour-input">
        <Input
          :value="line.BStdA4Ist"
          :onChange="(v) => setBackendData(v, 'BStdA4Ist', line.date)"
          form-group-id="BStdA4Ist"
          placeholder=""
          type="number"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import PageHeader from '../../common/page-header';
import Input from '../../common/input';
import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';


export default {
  title: 'Lines',
  components: { PageHeader, Input, Loader, BlockHeader, Select },
  props: {
    backendData: {
      type: Object,
      default: () => {},
    },
    setBackendData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      moment: moment,
      typeOptions: ['', 'f', 'm'],
    };
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: scroll;
}

.no-top-padding {
  padding-top: 0;
}

.line-header-wrapper {
  display: flex;
  background: rgb(247, 247, 249);
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 30px;
  div {
    display: flex;
    align-items: center;
    background: #f7f7f9;
  }
}

.line-wrapper {
  display: flex;
}

.hour-input {
  min-width: 95px;
  flex: 1;
  padding: 0 5px;
}

.number-text {
  min-width: 100px;
  width: 100px;
  padding: 0 5px;
  text-align: center;
  justify-content: center;
}

.date-text {
  min-width: 110px;
  width: 110px;
  padding: 0 5px;
}

.type-input {
  min-width: 150px;
  width: 150px;
  padding: 0 5px;
}

.hint-input {
  min-width: 150px;
  width: 150px;
  padding: 0 5px;
}
</style>
